import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-uservoice",
  "use": "icon-uservoice-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-uservoice\"><path d=\"M855 294h-22v317h22q40 0 74.5-20.5t55-55T1005 460v-16q0-41-20.5-75T930 315t-75-20h-1zm20 276V338q38 9 62.5 39.5T962 447l1 14q0 39-24.5 69.5T876 570h-1zM860 32q-4-3-10-3t-11 3L465 238H195q-53 0-98 26.5T26 336 0 434v22q0 53 26 98t71 71.5 98 26.5h279l366 201q5 3 10.5 3t10.5-3q11-6 11-18V50q-2-11-12-18zM40 445v-9q0-42 21-78t56.5-57 78.5-22h258v332H196q-43-1-78.5-22.5t-56.5-58T40 452v-7zm789 353L493 615V270q2-1 3-4L829 85v714-1zM348 963q21-22 21-53 0-20-9-37-35-54-47-143-7-45-6-84 0-9-5.5-15t-14-6-14.5 6-6 15v1q-1 47 6 96 13 95 52 156 4 6 4 14 0 10-7 19H210V646q0-9-6.5-15t-15-6-14.5 6-6 15v304q0 9 6 15t14 6h145q9 0 15-8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/uservoice.svg
// module id = 1138
// module chunks = 2